import { createAsyncThunk } from "@reduxjs/toolkit";
import { offlineSearchSuggestion } from "../offlineSearchService";
import { searchApi } from "../../../api/searchApi";
import {
  setApiReachable,
  setApiUnreachable,
} from "../../networkStatus/networkStatusSlice";
import offlineOrTimeoutPromise from "../utils/offlineOrTimeoutPromise";

const returnPayload = (suggestionArray, online) => ({
  suggestions: suggestionArray,
  isOffline: !online,
});

export const drugSearchSuggestionsThunk = createAsyncThunk(
  'enhancedSearch/drugSearchSuggestions',
  async (arg, { dispatch }) => {
    const { searchText } = arg;
    try {
      const suggestionApiPromise = searchApi.drugSearchSuggestion(searchText);
      const suggestionArray = await Promise.race([
        suggestionApiPromise,
        offlineOrTimeoutPromise(),
      ]);
      dispatch(setApiReachable());
      return returnPayload(suggestionArray, true);
    } catch (error) {
      dispatch(setApiUnreachable());
      try {
        const offlineArray = await offlineSearchSuggestion(searchText);
        return returnPayload(offlineArray, false);
      } catch (offlineError) {
        console.error(
          "Offline search also failed for drug suggestions:",
          offlineError
        );
        return returnPayload([], false);
      }
    }
  }
);